import {Box, Typography} from "@mui/material";
import "./ProjectHeaderComponent.css";
import React from "react";
import {Link} from "react-router-dom";
import {InfoOutlined as InfoIcon, KeyboardArrowLeft} from '@mui/icons-material';
import {formatMonthYear} from "../../Utils/date";
import {slugify} from "../../Utils/url";

interface Breadcrumb {
    name: string;
    path: string;
}

interface Props {
    id: any;
    project: any;
    breadcrumbs: Breadcrumb[];
    backButton: any;
}


const ProjectHeaderComponent = (props: Props) => {
    return (
        
        <div className="project-details-top-sticky-card">
            <div className="project-details-top-sticky-card-back">
                {props.backButton &&
                <Link state={{ project: props.project }} style={{textDecoration: 'none', color: 'inherit', cursor: 'pointer',}} to={props.backButton.route}>
                    <Typography fontSize={22} fontWeight={700}>{props.backButton.title}</Typography>
                    <img
                        src="/images/arrow_down.png"
                        alt="up arrow"
                        className="sticky-arrow"
                    />
                </Link>
                }
            </div>
            <div autoFocus={true}>
                <Typography variant={'h1'} className="project-details-title">מיזמי תשתיות לאומיים</Typography>
                <Box component={'nav'} aria-label="ניווט breadcrumb" sx={{display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center'}}>
                    <Box
                        component="ol"
                        sx={{
                            listStyle: "none",
                            m: 0,
                            p: 0,
                            display: "flex",
                            flexDirection: "row",
                            gap: 1,
                            alignItems: "center",
                        }}
                    >
                        <Box component="li">
                            <Link 
                                style={{textDecoration: 'none', color: 'inherit', cursor: 'pointer',}} 
                                to={'/project-about/'+props.id+'/'+slugify(props.project.name)}
                                className="breadcrumb-link"
                            >
                                <Typography variant={'h2'} className="project-details-breadcrumbs">{props.project.name}</Typography>
                            </Link>
                        </Box>
                        {props.breadcrumbs.map((bc: Breadcrumb, index: number) => (
                            <React.Fragment key={`breadcrumb-${index}`}>
                                <Box component="li" aria-hidden="true">
                                    <KeyboardArrowLeft sx={{color: '#1293FE'}} />
                                </Box>
                                <Box component="li">
                                    <Link 
                                        style={{textDecoration: 'none', color: 'inherit', cursor: 'pointer',}} 
                                        to={bc.path}
                                        className="breadcrumb-link"
                                        aria-current={index === props.breadcrumbs.length - 1 ? 'page' : undefined}
                                    >
                                        <Typography sx={{color: '#0C3768', fontSize: '16px', fontWeight: 400}}>{bc.name}</Typography>
                                    </Link>
                                </Box>
                            </React.Fragment>
                        ))}
                    </Box>
                </Box>
                <Typography className="project-details-contractor">גוף מבצע: {props.project.current_stage.company}</Typography>
            </div>
            <Box bgcolor={'#1293FE'} borderRadius={'1rem'} padding={'0.8rem'} display={'flex'} gap={'10px'}>
                <InfoIcon
                    style={{
                        color: '#FFF',
                        width: 24,
                        height: 24,
                    }}
                />
                <Typography color={"white"} fontWeight={600}>
                    תאריך סיום משוער: {formatMonthYear(props.project.updated_end_date)}
                </Typography>
            </Box>
        </div>
    );
};

export default ProjectHeaderComponent;
